// 9fbef606107a605d69c0edbcd8029e5d
import endpoints from '../../endpoints';
import { getAllCookies } from '../../../utils/cookie.util';
import { getAPIConfig, getBrand, isClient, removeURLParameter } from '../../../utils';

const ALLOWED_COOKIES = [
  'WC_ACTIVEPOINTER',
  'WC_AUTHENTICATION_',
  'WC_GENERIC_ACTIVITYDATA',
  'WC_PERSISTENT',
  'WC_SESSION_ESTABLISHED',
  'WC_USERACTIVITY_',
  'cartItemsCount',
  'iShippingCookie',
  'tcp_isregistered',
  'TCP_INTLPRC',
  'LandingBrand',
  'QuantumMetricUserID',
  'orderSession',
  'irclickid',
  'tcpSessionInfo',
];

export const getFilteredCookies = (cookies) => {
  return (cookies || []).filter((cookie) => {
    return ALLOWED_COOKIES.find((allowedCookieName) => {
      const name = (cookie && cookie.split('=')[0]).trim() || '';
      return allowedCookieName === name || name.startsWith(allowedCookieName);
    });
  });
};

const formattedCookiesLikeWeb = (mobileCookie) => {
  return (mobileCookie || []).map((cookie) => `${cookie[0]}=${cookie[1]}`);
};

export const getMobileCookies = (cookie) => {
  const mobileCookie = Object.entries(cookie);
  return formattedCookiesLikeWeb(mobileCookie);
};

export const getPayloadCookieArray = () => {
  const informationCookies = getAllCookies().split(';');
  const filteredCookies = getFilteredCookies(informationCookies);
  return filteredCookies.map((str) => {
    const obj = Object.create(null);
    obj.name = str && str.split('=')[0].trim();
    obj.path = '/';
    obj.value = str && str.split('=')[1].trim();

    return obj;
  });
};

const applicationJSON = 'application/json';

export const NavigateXHR = async (cookie, headers = {}, brandName = '') => {
  const { domain } = getAPIConfig();
  const modifiedHeaders = { ...headers };
  const endPointNavigatePost = endpoints?.postV2NavigateService?.URI;
  const webServiceEndPoints = `${domain}${endPointNavigatePost}`;
  const brandId = getBrand();
  const brand = (brandName || brandId).toUpperCase();
  modifiedHeaders.brandIdToUpdateCookie = brand;

  const response = await fetch(webServiceEndPoints, {
    method: 'post',
    headers: {
      'Content-Type': applicationJSON,
      Accept: applicationJSON,
      ...modifiedHeaders,
    },
    credentials: 'include',
    body: JSON.stringify({ cookie: getPayloadCookieArray() }),
  });
  return response && response.json();
};

export const getNavigateXHR = ({ ct }) => {
  // cookie-token-from-cross-domain
  const { domain } = getAPIConfig();
  const endPointNavigatePost = endpoints?.postV2NavigateService?.URI;
  const webServiceEndPoints = `${domain}${endPointNavigatePost}`;
  const headers = {
    'Content-Type': applicationJSON,
    Accept: applicationJSON,
  };

  if (ct === 'logout') {
    headers.actionTaken = 'logout';
  }
  if (isClient()) {
    const url = removeURLParameter(window?.location?.href, 'ct');
    window.history.replaceState(null, '', url);
  }
  return fetch(webServiceEndPoints, {
    method: 'put',
    headers,
    credentials: 'include',
    body: JSON.stringify({ encodedCookie: ct }),
  })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};
